<template>
  <div>
    <Breadcrumbs :title="$t('offersList.tkliflrim')" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <h2>{{ $t('offersList.tkliflrim') }}</h2>
      <div class="row">
        <div class="col-lg-8">
          <div
            v-if="offers.length<1"
            class="alert alert-info"
          >
            {{ $t('offersList.heBirTklifinizQeydAlnmamdr') }}
          </div>

          <div
            v-for="(o,i) in offers"
            :key="i"
            class="card"
            @click.prevent="$router.push(`/dashboard/request/${o.request.id}`)"
          >
            <div class="card-body">
              <div class="row">
                <div class="col-6">
                  <p class="lead">
                    {{ $t('offersList.soru') }}
                  </p>

                  #{{ o.request.requestType }}{{ buildLongId(o.request.id) }}

                  <div class="mb-2 lead font-weight-bold">
                    {{ o.request.title }}
                  </div>
                </div>

                <div class="col-6">
                  <p class="lead">
                    {{ $t('offersList.mllif') }}
                  </p>

                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <img
                          :src="getPhoto(o.request.user.photo,'thumbnailCropped')"
                          class="img-thumbnail rounded-circle"
                          style="height: 50px;"
                          :alt="$t('offersList.avatar')"
                        >
                      </div>
                      <div>
                        <span class="text-dark">
                          {{ o.request.user.name }}  {{ o.request.user.surname }}
                        </span> <br>
                        <span class="text-primary ">
                          {{ o.request.company.name }} {{ getCompanyFormat(o.request.company.format) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="company"
          class="col-lg-4"
        >
          <div class="card">
            <div class="card-body">
              <div class="media align-items-center">
                <img
                  class="rounded-circle user-image border mr-2"
                  :src="getPhoto(company.logo,'thumbnailCropped')"
                  alt=""
                  style="width: 60px"
                >
                <div class="about">
                  <div class="name f-w-600">
                    {{ company.name }} {{ getCompanyFormat(company.format) }}
                  </div>
                  <div class="status">
                    {{ company.taxId }}
                  </div>
                </div>
              </div>

              <p class="mt-2">
                {{ $t('offersList.sizHazrdaCompanynameGetcompanyformatcompanyformatI', {name:company.name , companyName:getCompanyFormat(company.format)}) }}
                <strong> {{ getProfileName(profile) }} </strong> {{ $t('dashboardActiveCompanyCard.profilid') }} <strong>{{ position }}</strong>
                {{ $t('dashboardActiveCompanyCard.vzifsindFaliyytGstrirsiniz') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
    import {mapState} from "vuex";
    import { getOffers, } from "@/repositories/GeneralDataRepository";
    import {mediaBase} from "@/repositories/Repository";
    import {
        buildLongId,
        getCompanyFormat,
        getPhoto,
        getProfileName
    } from "@/repositories/Utils";


    export default {
        data() {
            return {
                mediaBase: mediaBase,
                offers: []
            }
        },
        computed: {
            ...mapState({
                token: state => state.auth.token,
                user: state => state.auth.user,
                company: state => state.auth.company,
                sessionType: state => state.auth.sessionType,
                profile: state => state.auth.profile,
                position: state => state.auth.position,
            }),
        },
        mounted() {

            this.getOffers();

        },
        methods: {

            getPhoto(path, size, defaultPhoto) {
                return getPhoto(path, size, defaultPhoto);
            },
            getProfileName(keyword) {
                return getProfileName(keyword,this.i18n);
            },
            getCompanyFormat(keyword) {
                return getCompanyFormat(keyword, this.$i18n.locale);
            },

            buildLongId(id) {
                return buildLongId(id, 5);
            },
            getOffers() {
                getOffers(this.token).then(data => {
                    if (data.code === 200) {
                        this.offers = data.offers;
                    } else {
                        this.$swal({
                            title: `Error ${data.code}`,
                            text: `${data.message}`,
                          icon: 'error'
                        }).then(() => {
                            window.location.reload();
                        })
                    }
                })
            },
        }


    }
</script>
<style>
    div.review canvas {
        position: relative !important;
    }

    div.review input {
        z-index: 1;
        display: inline-block;
    }
</style>
